import * as core from '../../../../../../../core'

import { query } from './edit-external-institution.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.external-institutions.widgets.edit-external-institution',
    description: 'Edit External Institution',
    name: 'Edit External Institution',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
